export default __webpack_public_path__ + "static/media/mssqllogo.53428886.png";